const AUTOCOMPLETE_BASE = 'https://us-autocomplete-pro.api.smarty.com/lookup';
const STREET_BASE = 'https://us-street.api.smarty.com/street-address';
function shouldUseAutocompleteGeo(ip) {
  if (process.env.SMARTY_AUTOCOMPLETE_PREFER_GEO !== 'city') return false;
  return /^(\d{1,3}\.){3}\d{1,3}$/.test(String(ip || '').trim());
}
export function isSmartyConfigured() {
  const id = process.env.SMARTY_AUTH_ID || '';
  const token = process.env.SMARTY_AUTH_TOKEN || '';
  return Boolean(String(id).trim() && String(token).trim());
}
function authParams() {
  const authId = String(process.env.SMARTY_AUTH_ID || '').trim();
  const authToken = String(process.env.SMARTY_AUTH_TOKEN || '').trim();
  return {
    authId,
    authToken
  };
}
export async function smartySuggest(search, selected, clientIp) {
  const {
    authId,
    authToken
  } = authParams();
  if (!authId || !authToken) {
    return {
      suggestions: [],
      configured: false
    };
  }
  const q = String(search || '').trim().slice(0, 32);
  if (!q) return {
    suggestions: [],
    configured: true
  };
  const ip = String(clientIp || '').split(',')[0].trim().replace(/^\[|\]$/g, '');
  const useGeo = shouldUseAutocompleteGeo(ip);
  const baseParams = () => {
    const p = new URLSearchParams({
      'auth-id': authId,
      'auth-token': authToken,
      search: q,
      source: 'all',
      max_results: '10'
    });
    if (selected) p.set('selected', selected);
    p.set('prefer_geolocation', useGeo ? 'city' : 'none');
    return p;
  };
  const headers = useGeo ? {
    'X-Forwarded-For': ip
  } : {};
  const params = baseParams();
  const res = await fetch(`${AUTOCOMPLETE_BASE}?${params}`, {
    headers
  });
  if (!res.ok) {
    return {
      suggestions: [],
      configured: true,
      status: res.status
    };
  }
  const data = await res.json();
  const raw = Array.isArray(data?.suggestions) ? data.suggestions : Array.isArray(data?.result) ? data.result : [];
  if (process.env.NM_DEBUG_ADDRESS_AC === '1' && raw.length === 0) {
    console.log('[nm-address-ac:smarty] empty suggestions', {
      searchLen: q.length,
      responseKeys: data && typeof data === 'object' ? Object.keys(data) : []
    });
  }
  return {
    suggestions: raw,
    configured: true
  };
}
export async function smartyVerify(addr) {
  const {
    authId,
    authToken
  } = authParams();
  if (!authId || !authToken) {
    return {
      ok: false,
      error: 'not_configured'
    };
  }
  const params = new URLSearchParams({
    'auth-id': authId,
    'auth-token': authToken,
    street: String(addr.street || '').trim(),
    city: String(addr.city || '').trim(),
    state: String(addr.state || '').trim(),
    zipcode: String(addr.zipcode || '').trim(),
    match: 'enhanced'
  });
  const sec = String(addr.secondary || '').trim();
  if (sec) params.set('secondary', sec);
  const res = await fetch(`${STREET_BASE}?${params}`);
  if (!res.ok) {
    return {
      ok: false,
      error: `http_${res.status}`
    };
  }
  const raw = await res.json();
  const rows = Array.isArray(raw) ? raw : raw && typeof raw === 'object' ? [raw] : [];
  if (rows.length === 0) {
    return {
      ok: false,
      error: 'no_match'
    };
  }
  const row = rows.find(r => {
    const code = r?.analysis?.dpv_match_code;
    return code === 'Y' || code === 'S' || code === 'D';
  }) || rows[0];
  const code = row?.analysis?.dpv_match_code;
  const delivery = String(row?.delivery_line_1 || '').trim();
  const last = String(row?.last_line || '').trim();
  if (!delivery && !last) {
    return {
      ok: false,
      error: 'no_match'
    };
  }
  const formatted = last ? `${delivery}, ${last}` : delivery;
  return {
    ok: true,
    formatted,
    dpvMatchCode: code || '',
    components: {
      street: row?.components?.primary_number ? [row.components.primary_number, row.components.street_predirection, row.components.street_name, row.components.street_suffix, row.components.street_postdirection].filter(Boolean).join(' ').replace(/\s+/g, ' ').trim() : '',
      secondary: row?.components?.secondary_number ? `${row.components.secondary_designator || ''} ${row.components.secondary_number}`.trim() : '',
      city: row?.components?.city_name || '',
      state: row?.components?.state_abbreviation || '',
      zipcode: row?.components?.zipcode || ''
    }
  };
}
export function buildSmartySelectedParam(s) {
  if (!s || !s.street_line) return '';
  const entries = Number(s.entries) || 0;
  if (entries <= 1) return '';
  const sec = String(s.secondary || '').trim();
  if (!sec) return '';
  return `${s.street_line} ${sec} (${entries}) ${s.city} ${s.state} ${s.zipcode}`;
}
